<template>
  <div id="app">
    <router-view/>

    <v-snackbar v-model="$store.getters.snackbar.show" :timeout="3000" top :color="$store.getters.snackbar.color">
      {{ $store.getters.snackbar.text }}
      <v-btn dark flat icon @click.native="$store.dispatch('closedSnackbar')">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
    <confirm ref="confirm"></confirm>
  </div>
</template>

<script>
  import Confirm from '@/components/Confirm'
  export default {
    components: { Confirm },
    name: 'App',
    created() {
      window.getApp = this
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue